import { render, staticRenderFns } from "./desglose_curso.vue?vue&type=template&id=f55d1b08"
import script from "./desglose_curso.vue?vue&type=script&lang=js"
export * from "./desglose_curso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports